import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Forgetpassword from '@/views/Forgetpassword'
import Monitor from '@/views/Monitor'
import VueAxios from "vue-axios";
import axios from "axios";
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use(VueAxios, axios);
Vue.use(VueRouter)



const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/Forgetpassword',
    name: 'Forgetpassword',
    component: Forgetpassword
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Monitor',
    name: 'Monitor',
    component: Monitor
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
